import React from 'react';
import Layout from '../../components/Layout/Layout';
import GeoFencingAdmin from './GeoFencingAdmin';

const GeoFencingPage = () => {
    return (
        <Layout noSidebar={true}>
            <div className="bg-gray-50 min-h-screen p-3 sm:p-6">
                <div className="mb-4 sm:mb-6">
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Geo-Fencing Admin</h1>
                    <p className="text-sm sm:text-base text-gray-600 mt-1">Spatial Perimeter Management</p>
                </div>
                <GeoFencingAdmin />
            </div>
        </Layout>
    );
};

export default GeoFencingPage;
